import styled from '@emotion/styled';
import React from 'react';

export const DEFAULT_OFFSET = 48;

// use padding instead of margin to make sure the background-color is applied
// to the spacing as well. important when in sticky mode.
const PageToolbarContainer = styled('div')<{
  sticky?: boolean;
  offset?: number;
}>`
  ${(p) => (p.offset ? `top: ${p.offset}px;` : `top: ${DEFAULT_OFFSET}px;`)}
  ${(p) => (p.sticky ? `position: sticky;` : '')}

  background-color: ${(p) => p.theme.custom.colors.background.main};
  padding: ${(p) => `${p.theme.spacing(2)}px`};
  // negative margin is needed to block out the sides of elements when scrolling
  margin: ${(p) => `0 -${p.theme.spacing(2)}px ${p.theme.spacing(3)}px`};
  z-index: 2;
  @media (max-width: 600px) {
    padding-top: ${(p) => p.theme.spacing(2)}px;
  }
`;

const PageToolbarInner = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  row-gap: ${(p) => p.theme.spacing(2)}px;
  @media (max-width: 600px) {
    margin-top: 0;
    flex-direction: column;
    align-items: stretch;
  }
`;

export const PageToolbar = ({
  offset,
  sticky,
  children,
  backButton
}: {
  offset?: number;
  sticky?: boolean;
  children: React.ReactNode;
  backButton?: React.ReactNode;
}) => {
  return (
    <PageToolbarContainer offset={offset} sticky={sticky}>
      {backButton && <BackButtonContainer>{backButton}</BackButtonContainer>}

      <PageToolbarInner>{children}</PageToolbarInner>
    </PageToolbarContainer>
  );
};

export const PageToolbarActions = styled('div')<{
  justifyContent?: React.CSSProperties['justifyContent'];
  spacing?: 'dense' | 'wide';
}>`
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  align-self: flex-start;
  ${(p) =>
    p.justifyContent ? `justify-content: ${p.justifyContent};` : 'flex-end'}
  padding: ${(p) => `${p.theme.spacing(1)}px 0`};
  gap: ${(p) => p.theme.spacing(1)}px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    flex: 1;
  }
`;

export const PageToolbarTitle = styled('div')`
  flex: 1;
  display: flex;
`;

export const PageToolbarBack = styled('div')`
  display: flex;
  flex: 1;
`;

const BackButtonContainer = styled(`div`)`
  margin-bottom: ${(p) => p.theme.spacing(1)}px;
`;
